import { z } from 'zod'
import {
  eventDataSchema,
  userDataSchema,
  zodAddressCountString,
  zodLowerCaseString,
  zodNumber,
} from '../../common.schema'

export const LogoutSchema = z.object({
  event: z.literal('logout'),

  user_data: userDataSchema.required().extend({
    address_count: zodAddressCountString.optional(),
    email: zodLowerCaseString.optional(),
    lifetime_order_count: zodNumber.int().optional(),
  }),
  event_data: eventDataSchema,
})

export type LogoutEvent = z.infer<typeof LogoutSchema>
